import Content from "./Content";
import Head from "./Head";
import Imagebanner from "../../assets/images/bannertop.png";
import lineImage from "../../assets/images/line-art-large.png"

export default function Main() {
  return (
    <div className="main-body-sec">
      <div className="main-container-hero">
        <div className="ani-image-home">
          <img src={lineImage} alt="img" />
        </div>
        <div className="bannertop container">
          <img src={Imagebanner} alt="Lal Banner Image" className="banners" />
        </div>
      </div>
      <Head />
      <Content />
    </div>
  );
}
